<template>
    <el-tabs type="border-card" v-model="activeName" @tab-click="tabClickChange">
        <el-tab-pane label="道具资源" name="first">
            <!--<el-table :data="dataHandled" border>-->
            <!--<el-table-column label="大类">-->
            <!--<template slot-scope="scope">-->
            <!--<span v-for="item in options" v-if="item.value == scope.row.big_type">{{item.label}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column prop="id" label="编号">-->
            <!--</el-table-column>-->
            <!--<el-table-column label="名称">-->
            <!--<template slot-scope="scope">-->
            <!--<span>{{$t(scope.row.name)}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column label="描述">-->
            <!--<template slot-scope="scope">-->
            <!--<span>{{$t(scope.row.description)}}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <!--<el-table-column label="道具图标">-->
            <!--</el-table-column>-->
            <!--</el-table>-->

            <!--<div class="pagination">-->
            <!--<el-pagination @current-change="handleCurrentChange" :current-page="currentPage"-->
            <!--:page-size="pageSize"-->
            <!--layout="total, prev, pager, next, jumper" :total="totalRow">-->
            <!--</el-pagination>-->
            <!--</div>-->
            <div style="width: 80%;">
                <div v-for="item in options" style="margin-bottom: 20px;">
                    <div v-if="item.value == '0'" >
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow = !optionShow">{{optionShow?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp0" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+item.id+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{item.id +'-'+ $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '1'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow1 = !optionShow1">{{optionShow1?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in monsterConfigs" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow1">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/monster_icon/'+item.id+'.png'"
                                              fit="cover" @click="showMonsterDetail(item.id)"></el-image>
                                </template>
                                {{item.id +'-'+ $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <el-dialog :visible.sync="monsterDetailShow" width="40%" lock-scroll center>
                        <div class="monster-detail-img">
                            <el-image class="prop-img" :src="'./static/monster_icon/'+ monsterDetailId +'.png'"
                                      fit="cover"></el-image>
                        </div>


                        <div class="monster-detail-entire" v-for="item in monsterConfigs" :key="item.id" v-if="item.id == monsterDetailId">
                            <div style="width: 50%">
                                <div class="monster-detail-box">
                                    <span>怪兽名</span>
                                    <span class="monster-detail-name">{{$t(item.name)}}</span>
                                </div>

                                <div class="monster-detail-box">
                                    <div>种族</div>
                                    <div>
                                        <template v-for="(raceItem,raceIndex) in item.race.split('_')">
                                            <span v-for="i in monsterRaceOptions" v-if="raceItem == i.value">{{i.name + (raceIndex!==item.race.split('_').length-1?'/':'')}}</span>
                                        </template>
                                    </div>
                                </div>

                                <div class="monster-detail-box">
                                    <span>类型</span>
                                    <span v-if="item.type == 0">肉盾</span>
                                    <span v-if="item.type == 1">辅助</span>
                                    <span v-if="item.type == 2">输出</span>
                                </div>

                                <div class="monster-detail-box">
                                    <span>体力</span>
                                    <span>{{item.con}}</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>攻击力</span>
                                    <span>{{item.atk}}</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>移动速度</span>
                                    <span>{{item.mspd}}</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>霸气</span>
                                    <span>{{item.haki}}</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>每次普通攻击回复能量</span>
                                    <span>{{item.atk_energy_recover}}</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>攻击类型</span>
                                    <span v-if="item.atk_type == 0">近战</span>
                                    <span v-if="item.atk_type == 1">远程</span>
                                </div>
                                <template v-if="item.atk_type == 1">
                                    <div class="monster-detail-box">
                                        <span>射程</span>
                                        <span>{{item.atk_range}}</span>
                                    </div>
                                    <div class="monster-detail-box">
                                        <span>攻击速度</span>
                                        <span>{{item.atk_mspd}}</span>
                                    </div>
                                    <div class="monster-detail-box">
                                        <span>子弹速度</span>
                                        <span>{{item.bullet_speed}}</span>
                                    </div>
                                </template>
                                <div class="monster-detail-box">
                                    <span>体型</span>
                                    <span>{{item.size}}</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>真实伤害</span>
                                    <span>0</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>生物屏障</span>
                                    <span>0</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>普攻血量回复</span>
                                    <span>0</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>自愈血量回复</span>
                                    <span>0</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>血量回复效果</span>
                                    <span>100%</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>能量回复效果</span>
                                    <span>100%</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>增益效果持续时间</span>
                                    <span>100%</span>
                                </div>
                                <div class="monster-detail-box">
                                    <span>负面效果持续时间</span>
                                    <span>100%</span>
                                </div>
                            </div>

                            <div class="monster-detail-divider"></div>

                            <div style="width: 50%;height: 100%;">
                                <div class="monster-detail-skill" v-for="skillItem in item.abilities.split(',')">
                                    <div>
                                        <el-image class="prop-img" :src="'./static/monster_ability_icon/'+ skillItem +'.png'"
                                                  fit="cover"></el-image>
                                    </div>

                                    <div v-for="i in skillConfigData" v-if="skillItem == i.id">
                                        <div class="skill-name">{{$t(i.name)}}</div>
                                        <div>{{$t(i.description).replace('{name}',$t(item.name)).replaceAll('{owner}',$t(item.name)).replace('{p1}',i.p1).replace('{p2}',i.p2).replace('{p3}',i.p3).replace('{level_based}',i.level_based.split(',')[0]).replace('{energy}',item.atk_energy_recover)}}(每级提升{{i.level_based.split(',')[1]}})</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-dialog>

                    <div v-if="item.value == '2'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow2 = !optionShow2">{{optionShow2?'折叠':'展开'}}</el-button>
                            </template>
                            <template v-if="optionShow2">
                                <el-descriptions-item v-for="item in monsterConfigs" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="!(item.race.split('_').indexOf('4')!==-1 && item.quality < 4)">
                                    <template slot="label">
                                        <el-image class="prop-img"
                                                  :src="'./static/item_icon/'+(item.id + 10000)+'.png'"
                                                  fit="cover">
                                            <div slot="error" class="image-slot">
                                                <el-image class="prop-img"
                                                          :src="'./static/item_icon/0.png'"
                                                          fit="cover">
                                                </el-image>
                                            </div>
                                        </el-image>
                                    </template>
                                    {{(item.id + 10000) +'-' + $t(item.name) + $t('reward_editor.4')}}
                                </el-descriptions-item>
                            </template>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '3'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow3 = !optionShow3">{{optionShow3?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp3" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow3">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+item.id+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{item.id +'-' + $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '4'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="8" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow4 = !optionShow4">{{optionShow4?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp4" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow4">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+item.id+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{item.id +'-' + $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '5'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow5 = !optionShow5">{{optionShow5?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrConditionProp" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow5">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+item.id+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{item.id +'-' + $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '6'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow6 = !optionShow6">{{optionShow6?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp6" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow6">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+(item.id + 20000)+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{(item.id + 20000) +'-' + $t(item.name) + $t('reward_editor.17')}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '7'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="8" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow7 = !optionShow7">{{optionShow7?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in wallGainQualityConfig" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow7">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+item.id+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{item.id +'-' + $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '8'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow8 = !optionShow8">{{optionShow8?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp6" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow8">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+(item.id + 30000)+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{(item.id + 30000) +'-' + $t(item.name) + $t('reward_editor.18')}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '9'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="8" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow9 = !optionShow9">{{optionShow9?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp9" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow9">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+item.id+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{item.id +'-' + $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '10'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow10 = !optionShow10">{{optionShow10?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp10" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow10">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+item.id+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{item.id +'-' + $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '11'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow11 = !optionShow11">{{optionShow11?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp11" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow11">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+item.id+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{item.id +'-' + $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '12'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow12 = !optionShow12">{{optionShow12?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp12" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow12">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+item.id+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{item.id +'-' + $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '13'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow13 = !optionShow13">{{optionShow13?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp13" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow13">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+item.id+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{item.id +'-' + $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '14'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow14 = !optionShow14">{{optionShow14?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp14" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow14">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+item.id+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{item.id +'-' + $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '15'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow15 = !optionShow15">{{optionShow15?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp15" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow15">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+item.id+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{item.id +'-' + $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '16'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow16 = !optionShow16">{{optionShow16?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp16" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow16">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+item.id+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{item.id +'-' + $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '19'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow19 = !optionShow19">{{optionShow19?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp19" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow19">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+(item.id + 70000)+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{(item.id + 70000) +'-' + $t(item.name) + '的进化光谱'}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                    <div v-if="item.value == '20'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow20 = !optionShow20">{{optionShow20?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp20" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow20">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+item.id+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{item.id +'-' + $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '21'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow21 = !optionShow21">{{optionShow21?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp21" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow21">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+item.id+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{item.id +'-' + $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div v-if="item.value == '22'">
                        <el-descriptions :title="item.value + '(' + item.label + ')'" :column="6" border direction="vertical">
                            <template slot="extra">
                                <el-button type="text" size="small" @click="optionShow22 = !optionShow22">{{optionShow22?'折叠':'展开'}}</el-button>
                            </template>
                            <el-descriptions-item v-for="item in arrProp22" :key="item.id" contentStyle="text-align:center" labelStyle="text-align:center" v-if="optionShow22">
                                <template slot="label">
                                    <el-image class="prop-img" :src="'./static/item_icon/'+item.id+'.png'"
                                              fit="cover">
                                        <div slot="error" class="image-slot">
                                            <el-image class="prop-img"
                                                      :src="'./static/item_icon/0.png'"
                                                      fit="cover">
                                            </el-image>
                                        </div>
                                    </el-image>
                                </template>
                                {{item.id +'-' + $t(item.name)}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="怪兽进化配方" name="second">
            <div v-for="item in evolutions">
                <div v-if="item.id !== '/'" class="evolutions-entire">
                    <!--<span><el-image class="prop-img" :src="'./static/monster_icon/'+item.id+'.png'"-->
                    <!--fit="cover"></el-image></span>-->
                    <span class="monster-name" v-for="_item in monsterConfigs" v-if="item.id == _item.id">{{_item.id +'-'+ $t(_item.name)}}</span>

                    <div class="add-text">=</div>
                    <div v-for="i in item.material.split(',')" class="material-box">
                        <div v-for="(j,index) in i.split('_')" class="material-content">
                            <div v-if="index ==0">
                                <el-image v-if="j>10000" class="prop-img" :src="'./static/item_icon/'+ j +'.png'"
                                          fit="cover">
                                    <div slot="error" class="image-slot">
                                        <el-image class="prop-img"
                                                  :src="'./static/item_icon/0.png'"
                                                  fit="cover">
                                        </el-image>
                                    </div>
                                </el-image>

                                <el-image v-if="j>0 && j<10000" class="prop-img" :src="'./static/monster_icon/'+ j +'.png'"
                                          fit="cover"></el-image>
                                <div v-for="item0 in arrProp0" v-if="item0.id == j">{{item0.id +'-'+ $t(item0.name)}}</div>
                                <div v-for="item3 in arrProp3" v-if="item3.id == j">{{item3.id +'-'+ $t(item3.name)}}</div>
                                <div v-for="item5 in arrConditionProp" v-if="item5.id == j">{{item5.id +'-'+ $t(item5.name)}}</div>
                                <div v-for="item2 in monsterConfigs" v-if="item2.id == j">{{item2.id +'-'+ $t(item2.name)}}</div>
                            </div>
                            <div v-if="index ==1">({{j}})</div>
                        </div>
                        <div class="add-text">+</div>
                    </div>

                    <div class="oid-box">
                        <span><el-image class="prop-img" :src="'./static/monster_icon/'+item.oid+'.png'"
                                        fit="cover"></el-image></span>
                        <span v-for="__item in monsterConfigs" v-if="item.oid == __item.id">{{__item.id +'-'+ $t(__item.name)}}</span>
                    </div>

                    <div v-for="m in monsterConfigs" v-if="item.id == m.id && m.race.split('_').length > 1 && m.quality == 4" class="awake-box">
                        <div class="add-text">+</div>
                        <div class="awake-content">
                            <el-image class="prop-img" :src="'./static/item_icon/'+(parseInt(item.id) + 20000)+'.png'"
                                      fit="cover">
                                <div slot="error" class="image-slot">
                                    <el-image class="prop-img"
                                              :src="'./static/item_icon/0.png'"
                                              fit="cover">
                                    </el-image>
                                </div>
                            </el-image>
                            <span v-for="item6 in arrProp6" v-if="item6.id == item.id">{{item6.id +'-'+ $t(item6.name) + $t('reward_editor.17')}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </el-tab-pane>
        <el-tab-pane label="机器人名字处理" name="third">
            <el-form :inline="true">
                <el-form-item label="组合数据">
                    <el-upload class="upload-demo" :action="uploadUrl"
                               :on-change="importFile2" :auto-upload="false" :show-file-list="false">
                        <el-button size="small" type="primary">导入</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="exportFile2">导出</el-button>
                </el-form-item>
            </el-form>

            <el-form :inline="true">
                <el-form-item label="清洗数据">
                    <el-upload class="upload-demo" :action="uploadUrl"
                               :on-change="importFile" :auto-upload="false" :show-file-list="false">
                        <el-button size="small" type="primary">导入</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="exportFile">导出</el-button>
                </el-form-item>
            </el-form>
        </el-tab-pane>
        <el-tab-pane label="超2对照格式" name="fourth">
            <el-table :data="comparisonFormatData" border style="width: 100%">
                <el-table-column prop="number" label='序号'>
                </el-table-column>
                <el-table-column prop="tableName" label='表名'>
                </el-table-column>
                <el-table-column prop="name" label='中文名'>
                </el-table-column>
                <el-table-column label='操作'>
                    <template slot-scope="scope">
                        <el-button type="text" @click="exportComparisonFormat(scope.row.number,scope.row.tableName)">导出</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
    import commonApi from '../service/common_api'
    import confApi from '../service/conf_api'
    import paginationController from '../mixins/pagination'
    import XLSX from 'xlsx';
    import {
        apis
    } from '../lib/apis'

    export default {
        name: "home_bak",
        data(){
            return{
                activeName: 'first',
                options: [
                    {
                        value: '0',
                        label: this.$t("reward_editor.39")
                    },
                    {
                        value: '1',
                        label: this.$t("reward_editor.40")
                    },
                    {
                        value: '2',
                        label: this.$t("reward_editor.41")

                    },
                    {
                        value: '3',
                        label: this.$t("reward_editor.42")
                    },
                    {
                        value: '4',
                        label: this.$t("reward_editor.43")
                    },
                    {
                        value: '5',
                        label: '约束性道具'
                    },
                    {
                        value: '6',
                        label: this.$t("reward_editor.44")
                    },
                    {
                        value: '7',
                        label: '战纹'
                    },
                    {
                        value: '8',
                        label: this.$t("reward_editor.46")
                    },
                    {
                        value: '9',
                        label: this.$t("reward_editor.47")
                    },
                    {
                        value: '10',
                        label: '回复类道具'
                    },
                    {
                        value: '11',
                        label: '头像'
                    },
                    {
                        value: '12',
                        label: '头像框'
                    },
                    {
                        value: '13',
                        label: '宝箱'
                    },
                    {
                        value: '14',
                        label: '皮肤'
                    },
                    {
                        value: '15',
                        label: '时效类道具'
                    },
                    {
                        value: '17',
                        label: '起源盘'
                    },
                    {
                        value: '19',
                        label: '进化光谱'
                    },
                    {
                        value: '20',
                        label: '聊天框'
                    } ,
                    {
                        value: '21',
                        label: '战斗框'
                    } ,
                    {
                        value: '22',
                        label: '元核碎片'
                    }
                ],

                arrProp0: [],
                arrProp3: [],
                arrProp4: [],
                arrProp6: [],
                arrProp7: [],
                arrProp9: [],
                arrProp10: [],
                arrProp11: [],
                arrProp12: [],
                arrProp13: [],
                arrProp14: [],
                arrProp15: [],
                arrProp16: [],
                arrProp17: [],
                arrProp18: [],
                arrProp19: [],
                arrProp20: [],
                arrProp21: [],
                arrProp22: [],
                arrConditionProp:[],
                monsterConfigs: [],
                propConfig: [],
                emblemEffectConfig: [],
                godConfigs: [],
                wallGainType: [],
                skinGainType: [],
                emblemEntryConfigs: [],
                emblemMainConfigs: [],
                emblemFateConfigs: [],
                wallGainQualityConfig: [
                    {id: 0,name: "白"},
                    {id: 1,name: "绿"},
                    {id: 2,name: "蓝"},
                    {id: 3,name: "紫"},
                    {id: 4,name: "橙"},
                    {id: 5,name: "红"},
                    {id: 100,name: "随机品质"},
                ],

                evolutions: [],

                uploadUrl: apis.conf_upload,
                exportData: [],
                exportData2: [],

                monsterDetailShow: false,
                monsterDetailId: '',

                // 怪兽种族
                monsterRaceOptions: [
                    {
                        name: '祖龙族',
                        value: 0
                    },
                    {
                        name: '尸鬼族',
                        value: 1
                    },
                    {
                        name: '星灵族',
                        value: 2
                    },
                    {
                        name: '木偶族',
                        value: 3
                    },
                    {
                        name: '远古族',
                        value: 4
                    },
                    {
                        name: '原生族',
                        value: 5
                    }
                ],
                skillConfigData: [],

                optionShow: true,
                optionShow1: true,
                optionShow2: true,
                optionShow3: true,
                optionShow4: true,
                optionShow5: true,
                optionShow6: true,
                optionShow7: true,
                optionShow8: true,
                optionShow9: true,
                optionShow10: true,
                optionShow11: true,
                optionShow12: true,
                optionShow13: true,
                optionShow14: true,
                optionShow15: true,
                optionShow16: true,
                optionShow19: true,
                optionShow20: true,
                optionShow21: true,
                optionShow22: true,

                // 超2对照格式
                comparisonFormatData: [
                    {
                        number: 1,
                        tableName: 'monster_config_id',
                        name: '怪兽信息'
                    },
                    {
                        number: 2,
                        tableName: 'product_contrast',
                        name: '付费礼包类型'
                    },
                    // {
                    //     number: 3,
                    //     tableName: 'creation_rewards'
                    // },
                    {
                        number: 4,
                        tableName: 'play_contrast',
                        name: '玩法模式'
                    },
                    {
                        number: 5,
                        tableName: 'god_config_contrast',
                        name: '神灵信息'
                    },
                    {
                        number: 6,
                        tableName: 'building_contrast',
                        name: '建筑信息'
                    },
                    {
                        number: 7,
                        tableName: 'shop_contrast',
                        name: '商店信息'
                    },
                    // {
                    //     number: 8,
                    //     tableName: 'active_id_contrast'
                    // },
                    {
                        number: 9,
                        tableName: 'monster_choice_type_contrast',
                        name: '初始远古信息'
                    },
                    {
                        number: 10,
                        tableName: 'item_id_contrast',
                        name: '道具信息'
                    },
                    {
                        number: 11,
                        tableName: 'market_id_contrast',
                        name: '集市信息'
                    },
                    {
                        number: 12,
                        tableName: 'chat_channel_contrast',
                        name: '频道信息'
                    },
                    {
                        number: 13,
                        tableName: 'item_change_reason_contrast',
                        name: '道具原因'
                    },
                    // {
                    //     number: 14,
                    //     tableName: 'sub_reason_contrast'
                    // },
                    {
                        number: 15,
                        tableName: 'god_contract_config_id_contrast',
                        name: '神灵契约'
                    },
                    {
                        number: 16,
                        tableName: 'login_type_contrast',
                        name: '登录类型'
                    },
                    {
                        number: 17,
                        tableName: 'active_sub_id_contrast',
                        name: '活动类型'
                    },
                    // {
                    //     number: 18,
                    //     tableName: 'event_task_type_contrast'
                    // },
                    // {
                    //     number: 19,
                    //     tableName: 'forest_operation_type_contrast'
                    // },
                    // {
                    //     number: 20,
                    //     tableName: 'forest_node_type_contrast'
                    // },
                    // {
                    //     number: 21,
                    //     tableName: 'mixed_message_type_contrast'
                    // },
                ],
                formatData1 : [],
                formatData2 : [],
                formatData3 : [],
                formatData4 : [],
                formatData5 : [],
                formatData6 : [],
                formatData7 : [],
                formatData8 : [],
                formatData9 : [],
                formatData10 : [],
                formatData11 : [],
                formatData12 : [],
                formatData13 : [],
                formatData14 : [],
                formatData15 : [],
                formatData16 : [],
                formatData17 : [],
                formatData18 : [],
                formatData19 : [],
                formatData20 : [],
                formatData21 : [],

                productTypeNameData: [
                    {
                        type: 'pay',
                        name: '6档彩钻充值'
                    },
                    {
                        type: 'diamondPay',
                        name: '钻石兑换'
                    },
                    {
                        type: 'bp',
                        name: '战令'
                    },
                    {
                        type: 'card',
                        name: '月卡'
                    },
                    {
                        type: 'card2',
                        name: '大月卡'
                    },
                    {
                        type: 'gift',
                        name: '限购礼包'
                    },
                    {
                        type: 'dailyGift',
                        name: '每日礼包'
                    },
                    {
                        type: 'timeGift',
                        name: '限时礼包'
                    },
                    {
                        type: 'exchangeGift',
                        name: '兑换码礼包'
                    }
                ],

                playContrastData: [
                    {
                        play_module: 1,
                        play_module_name: '普通关卡'
                    },
                    {
                        play_module: 2,
                        play_module_name: '领域副本'
                    },
                    {
                        play_module: 3,
                        play_module_name: '世界之王'
                    },
                    {
                        play_module: 4,
                        play_module_name: '强敌'
                    },
                    {
                        play_module: 5,
                        play_module_name: '乱入-敌袭'
                    },
                    {
                        play_module: 6,
                        play_module_name: '异象-复制体'
                    },
                    {
                        play_module: 7,
                        play_module_name: '狩猎'
                    },
                    {
                        play_module: 8,
                        play_module_name: '古纪战役'
                    },
                    {
                        play_module: 9,
                        play_module_name: '竞技场'
                    },
                    {
                        play_module: 10,
                        play_module_name: '黑暗森林'
                    },
                    {
                        play_module: 11,
                        play_module_name: '永生之茧'
                    },
                    {
                        play_module: 12,
                        play_module_name: '起源殿'
                    },
                    {
                        play_module: 13,
                        play_module_name: '暴走旷野'
                    },
                    {
                        play_module: 14,
                        play_module_name: '神秘商人'
                    },
                    {
                        play_module: 15,
                        play_module_name: '探索节点遭遇'
                    },
                    {
                        play_module: 16,
                        play_module_name: '凿星裂痕'
                    },
                    {
                        play_module: 17,
                        play_module_name: '部落冒险/图腾'
                    },
                    {
                        play_module: 18,
                        play_module_name: '部落战'
                    },
                    {
                        play_module: 19,
                        play_module_name: '部落纷争区域'
                    },
                    {
                        play_module: 20,
                        play_module_name: '凿星组队'
                    },
                    {
                        play_module: 21,
                        play_module_name: '浮空巨塔'
                    },
                    {
                        play_module: 22,
                        play_module_name: '活动-连环击破'
                    },
                    {
                        play_module: 23,
                        play_module_name: '活动-七王轮战'
                    },
                    {
                        play_module: 24,
                        play_module_name: '活动-一创到底'
                    },
                    {
                        play_module: 25,
                        play_module_name: '活动-创世竞猜'
                    },
                    {
                        play_module: 26,
                        play_module_name: '活动-突围鏖战'
                    },
                    {
                        play_module: 27,
                        play_module_name: '活动-合围破阵'
                    },

                ],

                buildingContrastData: [
                    {
                        building_id: 1,
                        building_name: '领地'
                    },
                    {
                        building_id: 2,
                        building_name: '骨场'
                    },
                    {
                        building_id: 3,
                        building_name: '木场'
                    },
                    {
                        building_id: 4,
                        building_name: '鳞场'
                    },
                    {
                        building_id: 5,
                        building_name: '仓库'
                    },
                    {
                        building_id: 6,
                        building_name: '探索营地'
                    },
                    {
                        building_id: 7,
                        building_name: '起源基石'
                    },
                    {
                        building_id: 8,
                        building_name: '一发入魂商店'
                    },
                    {
                        building_id: 9,
                        building_name: '斗技场'
                    },
                    {
                        building_id: 10,
                        building_name: '黑暗森林'
                    },
                    {
                        building_id: 11,
                        building_name: '迷之巢穴'
                    },
                    {
                        building_id: 12,
                        building_name: '起源殿'
                    },
                    {
                        building_id: 13,
                        building_name: '战墙'
                    },
                    {
                        building_id: 14,
                        building_name: '学舌鸦'
                    },
                    {
                        building_id: 15,
                        building_name: '造物台'
                    },
                    {
                        building_id: 16,
                        building_name: '祭坛'
                    },
                    {
                        building_id: 17,
                        building_name: '永生之茧'
                    },
                    {
                        building_id: 18,
                        building_name: '凿星裂痕'
                    },
                    {
                        building_id: 19,
                        building_name: '部落营地'
                    }
                ],
                monsterChoiceTypeContrastData: [
                    {
                        monster_choice_type: 65,
                        name: '混沌'
                    },
                    {
                        monster_choice_type: 73,
                        name: '传说'
                    },
                    {
                        monster_choice_type: 81,
                        name: '逆转'
                    }
                ],

                chatChannelContrastData: [
                    {
                        chat_channel: 1,
                        name: '系统频道'
                    },
                    {
                        chat_channel: 2,
                        name: '世界频道'
                    },
                    {
                        chat_channel: 3,
                        name: '公会频道'
                    },
                    {
                        chat_channel: 4,
                        name: '招募频道'
                    },
                    {
                        chat_channel: 5,
                        name: '组队频道'
                    },
                    {
                        chat_channel: 100,
                        name: '好友私聊频道'
                    },
                    {
                        chat_channel: 200,
                        name: '异象聊天'
                    }
                ],

                changeReasonOptions: [
                    {
                        "label": "未定义",
                        "value": 0
                    },
                    {
                        "label": "代金券（消耗）",
                        "value": 10002
                    },
                    {
                        "label": "道具（数量更新）",
                        "value": 10003
                    },
                    {
                        "label": "好友（领取资源）",
                        "value": 10005
                    },
                    {
                        "label": "好友（一键领取资源）",
                        "value": 10006
                    },
                    {
                        "label": "好友（扩充好友位）",
                        "value": 10007
                    },
                    {
                        "label": "宝藏（钻石兑换）",
                        "value": 10009
                    },
                    {
                        "label": "玩家（新建角色）",
                        "value": 10011
                    },
                    {
                        "label": "玩家（登录）",
                        "value": 10012
                    },
                    {
                        "label": "玩家（登出）",
                        "value": 10013
                    },
                    {
                        "label": "头像（切换）",
                        "value": 10014
                    },
                    {
                        "label": "世界回响（领取奖励）",
                        "value": 10015
                    },
                    {
                        "label": "任务（领取奖励）",
                        "value": 10016
                    },
                    {
                        "label": "头像与头像框（购买）",
                        "value": 10017
                    },
                    {
                        "label": "异象（帮助奖励）",
                        "value": 10018
                    },
                    {
                        "label": "玩家（等级提升）",
                        "value": 10019
                    },
                    {
                        "label": "道具（资源同步）",
                        "value": 10020
                    },
                    {
                        "label": "玩家（头像框切换）",
                        "value": 10021
                    },
                    {
                        "label": "大世界（主城切换）",
                        "value": 10022
                    },
                    {
                        "label": "大世界（首通关卡）",
                        "value": 10023
                    },
                    {
                        "label": "充值成功",
                        "value": 10024
                    },
                    {
                        "label": "玩家（修改昵称）",
                        "value": 10025
                    },
                    {
                        "label": "玩家（战力最高点更新）",
                        "value": 10026
                    },
                    {
                        "label": "玩家（当前战力变更）",
                        "value": 10027
                    },
                    {
                        "label": "斗技场（最高分更新）",
                        "value": 10028
                    },
                    {
                        "label": "起源殿（最高分更新）",
                        "value": 10029
                    },
                    {
                        "label": "暴走旷野（最高击杀数更新）",
                        "value": 10030
                    },
                    {
                        "label": "凿星裂痕（首通列表更新）",
                        "value": 10031
                    },
                    {
                        "label": "永生之茧（首通列表更新）",
                        "value": 10032
                    },
                    {
                        "label": "星律跃进（资源速率更新）",
                        "value": 10033
                    },
                    {
                        "label": "好友助战（获得资源）",
                        "value": 10034
                    },
                    {
                        "label": "充值成功",
                        "value": 10036
                    },
                    {
                        "label": "代金券（消耗）",
                        "value": 10037
                    },
                    {
                        "label": "退款成功",
                        "value": 10038
                    },
                    {
                        "label": "怪兽（获得）",
                        "value": 20001
                    },
                    {
                        "label": "怪兽（基因解锁）",
                        "value": 20002
                    },
                    {
                        "label": "怪兽（基因批量转换）",
                        "value": 20003
                    },
                    {
                        "label": "怪兽（进化）",
                        "value": 20004
                    },
                    {
                        "label": "怪兽（购买性格点）",
                        "value": 20005
                    },
                    {
                        "label": "怪兽（锁定）",
                        "value": 20007
                    },
                    {
                        "label": "怪兽（升级技能）",
                        "value": 20012
                    },
                    {
                        "label": "饲星坛（批量饲星）",
                        "value": 20013
                    },
                    {
                        "label": "饲星坛（转化碎片）",
                        "value": 20014
                    },
                    {
                        "label": "怪兽（选择性格）",
                        "value": 20015
                    },
                    {
                        "label": "怪兽（等级提升）",
                        "value": 20016
                    },
                    {
                        "label": "怪兽（挑战领域副本）",
                        "value": 20017
                    },
                    {
                        "label": "怪兽极化（开始）",
                        "value": 20018
                    },
                    {
                        "label": "怪兽极化（取消）",
                        "value": 20019
                    },
                    {
                        "label": "怪兽极化（确认）",
                        "value": 20020
                    },
                    {
                        "label": "怪兽皮肤（购买）",
                        "value": 20021
                    },
                    {
                        "label": "怪兽皮肤（切换）",
                        "value": 20022
                    },
                    {
                        "label": "怪兽（修改前缀）",
                        "value": 20024
                    },
                    {
                        "label": "怪兽（更新战力）",
                        "value": 20025
                    },
                    {
                        "label": "怪兽（挑战领域副本）",
                        "value": 20026
                    },
                    {
                        "label": "饲星坛（重置怪兽）",
                        "value": 20029
                    },
                    {
                        "label": "怪兽（更新性格数据）",
                        "value": 20030
                    },
                    {
                        "label": "怪兽（获得同名觉醒）",
                        "value": 20031
                    },
                    {
                        "label": "怪兽（远古轮回）",
                        "value": 20032
                    },
                    {
                        "label": "怪兽（设置助战怪兽）",
                        "value": 20033
                    },
                    {
                        "label": "大世界（移动消耗）",
                        "value": 30001
                    },
                    {
                        "label": "野生怪兽（捕捉）",
                        "value": 30002
                    },
                    {
                        "label": "乱入事件（神灵邂逅）",
                        "value": 30003
                    },
                    {
                        "label": "乱入事件（神秘商人奖励）",
                        "value": 30004
                    },
                    {
                        "label": "乱入事件（敌袭奖励）",
                        "value": 30005
                    },
                    {
                        "label": "大世界（挑战强敌）",
                        "value": 30006
                    },
                    {
                        "label": "凿星裂痕（通关奖励）",
                        "value": 30007
                    },
                    {
                        "label": "野生怪兽（提升捕捉成功率）",
                        "value": 30008
                    },
                    {
                        "label": "世界之王（挑战）",
                        "value": 30009
                    },
                    {
                        "label": "凿星裂痕（打开宝箱）",
                        "value": 30010
                    },
                    {
                        "label": "狩猎（搜索敌人）",
                        "value": 30011
                    },
                    {
                        "label": "凿星裂痕（发布招募）",
                        "value": 30012
                    },
                    {
                        "label": "大世界（集市交换）",
                        "value": 30013
                    },
                    {
                        "label": "领地（建造建筑）",
                        "value": 30014
                    },
                    {
                        "label": "斗技场（开启号角）",
                        "value": 30015
                    },
                    {
                        "label": "领地（加速建造）",
                        "value": 30016
                    },
                    {
                        "label": "狩猎（挑战）",
                        "value": 30017
                    },
                    {
                        "label": "星律跃进（收集资源）",
                        "value": 30018
                    },
                    {
                        "label": "领地（取消建造）",
                        "value": 30019
                    },
                    {
                        "label": "星律跃进（跃进奖励）",
                        "value": 30020
                    },
                    {
                        "label": "大世界（世界之门传送）",
                        "value": 30021
                    },
                    {
                        "label": "大世界（挑战关卡）",
                        "value": 30022
                    },
                    {
                        "label": "异象（访问游荡智者）",
                        "value": 30023
                    },
                    {
                        "label": "异象（挑战复制体）",
                        "value": 30024
                    },
                    {
                        "label": "古记战役（挑战）",
                        "value": 30025
                    },
                    {
                        "label": "探索（领取）",
                        "value": 30026
                    },
                    {
                        "label": "斗技场（挑战）",
                        "value": 30027
                    },
                    {
                        "label": "世界之王（获得奖励）",
                        "value": 30028
                    },
                    {
                        "label": "狩猎（模式切换）",
                        "value": 30029
                    },
                    {
                        "label": "星律跃进（找回经验）",
                        "value": 30030
                    },
                    {
                        "label": "狩猎挑战（胜利奖励）",
                        "value": 30031
                    },
                    {
                        "label": "凿星首通（胜利奖励）",
                        "value": 30032
                    },
                    {
                        "label": "战墙（加固）",
                        "value": 40001
                    },
                    {
                        "label": "战墙（分解战纹）",
                        "value": 40002
                    },
                    {
                        "label": "黑暗森林（提升能力）",
                        "value": 50001
                    },
                    {
                        "label": "黑暗森林（重置能力）",
                        "value": 50002
                    },
                    {
                        "label": "黑暗森林（重置森林）",
                        "value": 50005
                    },
                    {
                        "label": "黑暗森林（领取奖励）",
                        "value": 50006
                    },
                    {
                        "label": "黑暗森林（立即探索节点）",
                        "value": 50007
                    },
                    {
                        "label": "黑暗森林（命运之泉）",
                        "value": 50008
                    },
                    {
                        "label": "黑暗森林（占卜兽）",
                        "value": 50009
                    },
                    {
                        "label": "黑暗森林（探索节点）",
                        "value": 50010
                    },
                    {
                        "label": "黑暗森林（战斗节点奖励）",
                        "value": 50011
                    },
                    {
                        "label": "永生之茧（刷新）",
                        "value": 60002
                    },
                    {
                        "label": "永生之茧（扫荡）",
                        "value": 60005
                    },
                    {
                        "label": "背包（扩展）",
                        "value": 70001
                    },
                    {
                        "label": "背包（合成怪兽碎片）",
                        "value": 70002
                    },
                    {
                        "label": "背包（合成觉醒水晶碎片）",
                        "value": 70003
                    },
                    {
                        "label": "道具（购买资源）",
                        "value": 70004
                    },
                    {
                        "label": "道具（使用头像与头像框）",
                        "value": 70006
                    },
                    {
                        "label": "道具（打开宝箱）",
                        "value": 70007
                    },
                    {
                        "label": "道具（初始化）",
                        "value": 70008
                    },
                    {
                        "label": "道具（自动回复）",
                        "value": 70009
                    },
                    {
                        "label": "商店（刷新）",
                        "value": 80001
                    },
                    {
                        "label": "商店（购买）",
                        "value": 80002
                    },
                    {
                        "label": "造物台（抽奖）",
                        "value": 80003
                    },
                    {
                        "label": "活动商店（购买）",
                        "value": 80004
                    },
                    {
                        "label": "造物台（购买）",
                        "value": 80005
                    },
                    {
                        "label": "邮件（领取）",
                        "value": 90001
                    },
                    {
                        "label": "邮件（一键领取）",
                        "value": 90002
                    },
                    {
                        "label": "起源殿（挑战）",
                        "value": 100002
                    },
                    {
                        "label": "起源殿（周悬赏奖励）",
                        "value": 100003
                    },
                    {
                        "label": "暴走旷野（点击迷之生物）",
                        "value": 101001
                    },
                    {
                        "label": "暴走旷野（切换古基因）",
                        "value": 101002
                    },
                    {
                        "label": "暴走旷野（升级古基因）",
                        "value": 101003
                    },
                    {
                        "label": "暴走旷野（重置古基因）",
                        "value": 101004
                    },
                    {
                        "label": "暴走旷野（挑战）",
                        "value": 101006
                    },
                    {
                        "label": "部落（创建）",
                        "value": 102001
                    },
                    {
                        "label": "部落营地（贡献）",
                        "value": 102002
                    },
                    {
                        "label": "部落营地（奖励）",
                        "value": 102003
                    },
                    {
                        "label": "部落冒险（挑战）",
                        "value": 102004
                    },
                    {
                        "label": "部落图腾（挑战）",
                        "value": 102005
                    },
                    {
                        "label": "部落拍卖所（出价）",
                        "value": 102006
                    },
                    {
                        "label": "部队（消除怪兽濒死）",
                        "value": 102007
                    },
                    {
                        "label": "部落遗迹（宣战）",
                        "value": 102008
                    },
                    {
                        "label": "部落遗迹（挑战）",
                        "value": 102009
                    },
                    {
                        "label": "部落遗迹（占领奖励）",
                        "value": 102010
                    },
                    {
                        "label": "部落功勋（奖励）",
                        "value": 102011
                    },
                    {
                        "label": "部落遗迹（挑战）",
                        "value": 102016
                    },
                    {
                        "label": "部落战（结算）",
                        "value": 102017
                    },
                    {
                        "label": "部落战（购买buff）",
                        "value": 102018
                    },
                    {
                        "label": "部落战挑战对手玩家（奖励）",
                        "value": 102019
                    },
                    {
                        "label": "部落战给与主将（奖励）",
                        "value": 102020
                    },
                    {
                        "label": "元核（强化）",
                        "value": 103001
                    },
                    {
                        "label": "元核（升阶）",
                        "value": 103002
                    },
                    {
                        "label": "元核（分解）",
                        "value": 103003
                    },
                    {
                        "label": "元核（鉴定）",
                        "value": 103004
                    },
                    {
                        "label": "元核（熔炼）",
                        "value": 103005
                    },
                    {
                        "label": "神灵（强化）",
                        "value": 104001
                    },
                    {
                        "label": "神灵（重置）",
                        "value": 104002
                    },
                    {
                        "label": "神灵契约（重置）",
                        "value": 104003
                    },
                    {
                        "label": "神灵契约（解锁）",
                        "value": 104004
                    },
                    {
                        "label": "神灵契约（升级）",
                        "value": 104005
                    },
                    {
                        "label": "活动（每日三发）",
                        "value": 105001
                    },
                    {
                        "label": "活动（领取奖励）",
                        "value": 105002
                    },
                    {
                        "label": "活动（一键领取）",
                        "value": 105003
                    },
                    {
                        "label": "活动（挑战连环击破）",
                        "value": 105004
                    },
                    {
                        "label": "活动（智者轮盘）",
                        "value": 105005
                    },
                    {
                        "label": "位面领主（领取奖励）",
                        "value": 105006
                    },
                    {
                        "label": "地鸣（领取奖励）",
                        "value": 105007
                    },
                    {
                        "label": "活动（里程碑奖励）",
                        "value": 105008
                    },
                    {
                        "label": "活动（里程碑奖励2）",
                        "value": 105009
                    },
                    {
                        "label": "活动（一步之遥）",
                        "value": 105010
                    },
                    {
                        "label": "活动（拼二大作战）",
                        "value": 105011
                    },
                    {
                        "label": "拉新（领取奖励）",
                        "value": 105012
                    },
                    {
                        "label": "一创到底（购买轮次）",
                        "value": 105013
                    },
                    {
                        "label": "一创到底（消耗挑战）",
                        "value": 105014
                    },
                    {
                        "label": "万象琥珀（奖励）",
                        "value": 105015
                    },
                    {
                        "label": "活动（七王轮战）",
                        "value": 105016
                    },
                    {
                        "label": "活动（周末许愿）",
                        "value": 105017
                    },
                    {
                        "label": "活动（万象礼遇）",
                        "value": 105018
                    },
                    {
                        "label": "活动（大漠行悬赏令）",
                        "value": 105019
                    },
                    {
                        "label": "活动（天降一掌）",
                        "value": 105020
                    },
                    {
                        "label": "活动（创友回归-购买等级）",
                        "value": 105021
                    },
                    {
                        "label": "浮空巨塔（挑战）",
                        "value": 106001
                    },
                    {
                        "label": "每日任务（领取奖励）",
                        "value": 107001
                    },
                    {
                        "label": "每日任务（活跃奖励）",
                        "value": 107002
                    },
                    {
                        "label": "支线任务（冒险奖励）",
                        "value": 107003
                    },
                    {
                        "label": "宝藏（首充大礼奖励）",
                        "value": 108001
                    },
                    {
                        "label": "蜕变契约（任务奖励）",
                        "value": 108002
                    },
                    {
                        "label": "蜕变契约（等级奖励）",
                        "value": 108003
                    },
                    {
                        "label": "每日礼包（免费）",
                        "value": 108004
                    },
                    {
                        "label": "每日买光（奖励）",
                        "value": 108005
                    },
                    {
                        "label": "每日礼包（购买）",
                        "value": 108006
                    },
                    {
                        "label": "蜕变契约（购买等级）",
                        "value": 108007
                    },
                    {
                        "label": "限购礼包（免费）",
                        "value": 108008
                    },
                    {
                        "label": "进化之实（奖励）",
                        "value": 108009
                    },
                    {
                        "label": "后台处理",
                        "value": 900001
                    },
                    {
                        "label": "扣除道具（后台）",
                        "value": 900002
                    }
                ],

                loginTypeContrastData: [
                    {
                        login_type: 1,
                        name: '正常登录'
                    },
                    {
                        login_type: 2,
                        name: '顶号登录'
                    },
                    {
                        login_type: 3,
                        name: '在线跨天'
                    },
                    {
                        login_type: 4,
                        name: '断线重连'
                    },
                    {
                        login_type: 5,
                        name: '账号首登'
                    }
                ],

                // 全部数据
                entireData: []

            };
        },
        mixins: [paginationController],
        mounted() {
            setTimeout(() => {
                this.initData();
                this.getReadData();
                this.initComparisonFormatData();
            },1000)
        },
        created() {

        },
        methods:{
            tabClickChange(tab,event) {
                if (tab.name == 'fourth') {
                    this.initComparisonFormatData();
                }
            },

            initData: function() {
                let self = this;
                let tables = 'monster_config,war_groove_config,skin_config,god_config,emblem_effect_config,prop_config';
                commonApi.getConfs({
                    tables: tables
                }).then(res => {
                    self.monsterConfigs = [];
                    self.propConfig = res.prop_config;
                    self.emblemEffectConfig = res.emblem_effect_config;
                    self.godConfigs = res.god_config;
                    self.wallGainType = res.war_groove_config;
                    self.skinGainType = res.skin_config;

                    res.monster_config.forEach(configItem=>{
                        if (configItem.special === 0){
                            self.monsterConfigs.push(configItem);
                            self.entireData.push(configItem);
                        }
                    })

                    self.wallGainQualityConfig.forEach(wallItem =>{
                        self.entireData.push(wallItem);
                    })

                    res.prop_config.forEach(propItem => {
                        self.entireData.push(propItem);
                    });

                    self.totalRow = self.entireData.length;
                    self.rawData = self.entireData;
                    self.dataHandled = self.entireData;


                    let arrProp0 = [];
                    let arrProp3 = [];
                    let arrProp4 = [];
                    let arrConditionProp = [];
                    let arrProp9 = [];
                    let arrProp10 = [];
                    let arrProp11 = [];
                    let arrProp12 = [];
                    let arrProp13 = [];
                    let arrProp14 = [];
                    let arrProp15 = [];
                    let arrProp16 = [];
                    let arrProp18 = [];
                    let arrProp20 = [];
                    let arrProp21 = [];
                    let arrProp22 = [];
                    res.prop_config.forEach(function(item) {
                        let type = item.big_type;
                        if (type == 0) {
                            arrProp0.push(item);
                        } else if (type == 3) {
                            arrProp3.push(item);
                        }  else if (type == 5) {
                            arrConditionProp.push(item);
                        }else if (type == 9) {
                            arrProp9.push(item);
                        }else if(type == 4){
                            arrProp4.push(item);
                        } else if (type == 10) {
                            arrProp10.push(item)
                        } else if (type == 11) {
                            arrProp11.push(item)
                        } else if (type == 12) {
                            arrProp12.push(item)
                        } else if (type == 13) {
                            arrProp13.push(item)
                        } else if (type == 14) {
                            arrProp14.push(item)
                        } else if (type == 15) {
                            arrProp15.push(item)
                        } else if (type == 16) {
                            arrProp16.push(item)
                        } else if (type == 20) {
                            arrProp20.push(item)
                        } else if (type == 21) {
                            arrProp21.push(item)
                        } else if (type == 22) {
                            arrProp22.push(item)
                        }
                    });
                    self.arrProp0 = arrProp0;
                    self.arrProp3 = arrProp3;
                    self.arrProp4 = arrProp4;
                    self.arrProp16 = arrProp16;
                    self.arrProp20 = arrProp20;
                    self.arrProp21 = arrProp21;
                    self.arrProp22 = arrProp22;
                    self.arrConditionProp = arrConditionProp;
                    //元核属性类型: 0-主属性;1-二字词条;2-四字词条;3-宿命
                    let tw = {
                        value: 1,
                        label: this.$t("reward_editor.37"),
                        children: []
                    };
                    let fw = {
                        value: 2,
                        label: this.$t("reward_editor.38"),
                        children: []
                    };
                    let special = {
                        value: 3,
                        label: this.$t("reward_editor.52"),
                        children: [{
                            value: 0,
                            label: this.$t("reward_editor.48"),
                        }]
                    }

                    let twConfigs = [];
                    let fwConfigs = [];
                    res.emblem_effect_config.forEach(function(item) {
                        if (item.type == 0) {
                            self.emblemMainConfigs.push(item);
                        } else if (item.type == 1) {
                            twConfigs.push({
                                value: item.id,
                                label: self.$t(item.name) + '('+self.$t(item.description)+')'
                            });
                        } else if (item.type == 2) {
                            fwConfigs.push({
                                value: item.id,
                                label: self.$t(item.name) + '('+self.$t(item.description)+')'
                            });
                        } else if (item.type == 3) {
                            self.emblemFateConfigs.push(item);
                        }
                    });
                    tw.children = twConfigs;
                    fw.children = fwConfigs;
                    self.emblemEntryConfigs.push(tw);
                    self.emblemEntryConfigs.push(fw);
                    self.emblemEntryConfigs.push(special);
                    self.arrProp9 = arrProp9;
                    self.arrProp10 = arrProp10;
                    self.arrProp11 = arrProp11;
                    self.arrProp12 = arrProp12;
                    self.arrProp13 = arrProp13;
                    self.arrProp14 = arrProp14;
                    self.arrProp15 = arrProp15;

                    let arrProp6 = [];
                    let arrProp19 = [];
                    self.monsterConfigs.forEach(function(item) {
                        let monsterRace = item.race;
                        let monsterQuality = item.quality;
                        let hyperEvolution = item.hyper_evolution;
                        if (monsterQuality === 4 && monsterRace.indexOf("_") > -1) {
                            arrProp6.push(item);
                        }
                        if (hyperEvolution ===1){
                            arrProp19.push(item);
                        }

                    });
                    self.arrProp6 = arrProp6;
                    self.arrProp19 = arrProp19;

                    let arrProp7 = [];
                    res.war_groove_config.forEach(function(item) {
                        let type = item.type;
                        if (type === 3 || type === 4) {
                            arrProp7.push(item);
                        }
                    });
                    self.arrProp7 = arrProp7;
                    //self.glyphFateType = arr2;

                    self.evolutions = [];
                    for (var i in self.monsterConfigs) {
                        var arr = self.monsterConfigs[i].evolutions.split("@");
                        for (var j in arr) {
                            self.evolutions.push({
                                id: arr[j].split("#")[0],
                                material: arr[j].split("#")[1],
                                oid: self.monsterConfigs[i].id
                            })
                        }
                    }
                })
            },

            importFile2(file, fileList) {
                this.readExcel2(file)
            },
            readExcel2(file) {
                const types = file.name.split('.')[1];
                const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types);

                if (!fileType) {
                    this.$message('格式错误！请重新选择!');
                    return
                }
                this.file2Xce2(file).then(tabJson => {
                    if (tabJson && tabJson.length > 0) {
                        var data = tabJson[0].sheet;
                        var dataA = [];
                        var dataB = [];
                        var dataC = [];

                        data.forEach(item => {
                            dataA.push(item[0])
                            dataB.push(item[1])
                        })

                        for (var i=0;i<dataA.length-1;i++) {
                            for (var j=0;j<dataB.length-1;j++) {
                                dataC.push(dataA[i] + dataB[j])
                            }
                        }

                        for (var i=0;i<=data.length-1;i++) {
                            for (var j=0;j<=dataC.length-1;j++) {
                                if (i == j) {
                                    data[i].push(dataC[j]);
                                }
                            }
                        }
                        dataC.splice(0,data.length)
                        dataC.forEach(item => {
                            data.push(["","",item])
                        })
                        this.exportData = data;
                        this.$message({
                            type: 'success',
                            message: '数据组合完毕!'
                        })
                    }
                })
            },
            file2Xce2(file) {
                return new Promise(function (resolve, reject) {
                    const reader = new FileReader();
                    reader.onload = function (e) {
                        const data = e.target.result;
                        this.wb = XLSX.read(data, {
                            type: 'binary'
                        })
                        console.log(this.wb);
                        const result = [];
                        this.wb.SheetNames.forEach((sheetName) => {
                            result.push({
                                sheetName: sheetName,
                                sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName],{header:1})
                            })
                        })
                        resolve(result)
                    }
                    reader.readAsBinaryString(file.raw)
                })
            },

            exportFile2() {
                const ws= XLSX.utils.aoa_to_sheet(this.exportData);

                /* generate workbook and add the worksheet */
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'sheet1');

                /* save to file */
                XLSX.writeFile(wb, '组合数据.xlsx');
            },

            importFile(file, fileList) {
                this.readExcel(file)
            },
            readExcel(file) {
                const types = file.name.split('.')[1];
                const fileType = ['xlsx', 'xlc', 'xlm', 'xls', 'xlt', 'xlw', 'csv'].some(item => item === types);

                if (!fileType) {
                    this.$message('格式错误！请重新选择!');
                    return
                }
                this.file2Xce(file).then(tabJson => {
                    if (tabJson && tabJson.length > 0) {
                        var data = tabJson[0].sheet;

                        // 去除空格 replace(/\s*/g,"")
                        // 去除数字 replace(/[0-9]/g, '')
                        // 去除英文 replace(/[a-z]/ig, '')
                        // 去符号 replace(/[`:_.~!@#$%^&*() \+ =<>?"{}|, \/ ;' \\ [ \] ·~！@#￥%……&*（）—— \+ ={}|《》？：“”【】、；‘’，。、\-]/g,'')
                        // 去除日文 replace(/[\u0800-\u4e00]/g,'')
                        // 去除中文 replace(/[\u4E00-\u9FA5]/g,'')
                        // replace(/[巛丶丿艹灬丨氵罒彡冫阝\-]/g,'')
                        var result = [];
                        var temp = '';
                        var arrA = [];
                        var arrB = [];
                        for (var i=0;i<=data.length-1;i++) {
                            for (var j=0;j<=data[i].length-1;j++) {
                                if (data[i][j] !== '' && data[i][j] !== null && data[i][j] !== undefined) {
                                    // temp = data[i][j].replace(/[^\u4E00-\u9FA5]/g,'')
                                    // if (temp !== '') {
                                    //     result.push([temp])
                                    // }
                                    arrA = data[i][j].split(',');
                                    arrA.forEach(itemA => {
                                        arrB = itemA.split(';');
                                        arrB.forEach(itemB => {
                                            temp = itemB.replace(/[^\u4E00-\u9FA5]/g,'')
                                            if (temp !== '') {
                                                result.push([temp])
                                            }
                                        })
                                    })
                                }
                            }
                        }

                        for(var i = 0; i < result.length-1; i++){
                            for(var j = i+1; j < result.length; j++){
                                if(result[i][0]===result[j][0]){
                                    result.splice(j,1);
                                    j--;
                                }
                            }
                        }

                        for(var i = 0; i < result.length-1; i++){
                            if(result[i][0].length > 6){
                                result.splice(i,1);
                            }
                        }

                        this.exportData2 = result;
                        this.$message({
                            type: 'success',
                            message: '数据清洗完毕!'
                        })
                    }
                })
            },
            file2Xce(file) {
                return new Promise(function (resolve, reject) {
                    const reader = new FileReader();
                    reader.onload = function (e) {
                        const data = e.target.result;
                        this.wb = XLSX.read(data, {
                            type: 'binary'
                        })
                        console.log(this.wb);
                        const result = [];
                        this.wb.SheetNames.forEach((sheetName) => {
                            result.push({
                                sheetName: sheetName,
                                sheet: XLSX.utils.sheet_to_json(this.wb.Sheets[sheetName],{header:1})
                            })
                        })
                        resolve(result)
                    }
                    reader.readAsBinaryString(file.raw)
                })
            },

            exportFile() {
                const ws= XLSX.utils.aoa_to_sheet(this.exportData2);

                /* generate workbook and add the worksheet */
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'sheet1');

                /* save to file */
                XLSX.writeFile(wb, '清洗数据.xlsx');
            },

            // 怪兽详细信息
            showMonsterDetail(id) {
                this.monsterDetailShow = true;
                this.monsterDetailId = id;
            },

            // 怪兽技能信息
            getReadData() {
                confApi.getReadData({
                    token: this.token,
                    tableName: 'skill_config'
                }).then(res => {
                    this.skillConfigData = res;
                })
            },

            // 整合超2对照格式数据
            initComparisonFormatData() {
                var data1 = [];
                var data2 = [];
                var data3 = [];
                var data4 = [];
                var data5 = [];
                var data6 = [];
                var data7 = [];
                var data8 = [];
                var data9 = [];
                var data10 = [];
                var data11 = [];
                var data12 = [];
                var data13 = [];
                var data14 = [];
                var data15 = [];
                var data16 = [];
                var data17 = [];
                var data18 = [];
                var data19 = [];
                var data20 = [];
                var data21 = [];
                commonApi.getConfs({
                    tables: 'monster_config,iap_buy_config,god_config,shop_config,prop_config,market_node_config,map_node,god_contract_config,activity_template_config'
                }).then(res => {
                    var type = '';
                    var attack_type = '';
                    var form = '';
                    res.monster_config.forEach(item => {
                        if (item.type == 0) {
                            type = '肉盾'
                        } else if (item.type == 1) {
                            type = '输出'
                        } else if (item.type == 2) {
                            type = '辅助'
                        }

                        if (item.atk_type == 0) {
                            attack_type = '近战'
                        } else  if (item.atk_type == 1) {
                            attack_type = '远程'
                        }

                        if (item.quality == 0) {
                            form = '幼体'
                        } else if (item.quality == 1) {
                            form = '幻化'
                        } else if (item.quality == 2) {
                            form = '究极'
                        } else if (item.quality == 3) {
                            form = '不朽'
                        } else if (item.quality == 4) {
                            if (item.race.split('_').length>1) {
                                form = '双种族觉醒'
                            } else {
                                form = '单种族觉醒'
                            }
                        }
                        data1.push({
                            id: item.id,
                            name: this.$t(item.name),
                            type: type,
                            attack_type: attack_type,
                            form: form
                        })

                        data10.push({
                            item_id: item.id,
                            item_name: this.$t(item.name),
                            item_type: 1,
                            item_type_name: ''
                        })
                        data10.push({
                            item_id: item.id + 10000,
                            item_name: this.$t(item.name) + this.$t('reward_editor.4'),
                            item_type: 2,
                            item_type_name: ''
                        })

                        let quality = item.quality;
                        let race = item.race;
                        if (quality === 4 && race.indexOf("_")>-1) {
                            data10.push({
                                item_id: item.id + 20000,
                                item_name: this.$t(item.name) + this.$t('reward_editor.17'),
                                item_type: 6,
                                item_type_name: ''
                            })

                            data10.push({
                                item_id: item.id + 30000,
                                item_name: this.$t(item.name) + this.$t('reward_editor.18'),
                                item_type: 8,
                                item_type_name: ''
                            })
                        }


                    })

                    var typeName = '';
                    res.iap_buy_config.forEach(item => {
                        this.productTypeNameData.forEach(typeItem => {
                            if (typeItem.type == item.type) {
                                typeName = typeItem.name;
                            }
                        })
                        data2.push({
                            product_id: item.id,
                            name: this.$t(item.name),
                            product_type: item.type,
                            product_type_name: typeName
                        })
                    })

                    res.god_config.forEach(item => {
                        data5.push({
                            god_config_id: item.id,
                            god_config_name: this.$t(item.name),
                        })
                    })

                    res.shop_config.forEach(item => {
                        data7.push({
                            shop_type: item.type,
                            shop_name: this.$t(item.name),
                        })
                    })

                    res.prop_config.forEach(item => {
                        data10.push({
                            item_id: item.id,
                            item_name: this.$t(item.name),
                            item_type: item.big_type,
                            item_type_name: ''
                        })
                    })

                    res.market_node_config.forEach(item => {
                        data11.push({
                            market_id: item.map_node_id,
                            name: '',
                        })
                    })

                    res.map_node.forEach(mapItem => {
                        data11.forEach(data11Item => {
                            if (mapItem.id == data11Item.market_id) {
                                data11Item.name = this.$t(mapItem.name);
                            }
                        })
                    })

                    res.god_contract_config.forEach(item => {
                        data15.push({
                            god_contract_config_id: item.id,
                            name: this.$t(item.name),
                        })
                    })

                    res.activity_template_config.forEach(item => {
                        data17.push({
                            active_sub_id: item.id,
                            name: item.record,
                        })
                    })
                })
                this.formatData1 = data1;
                this.formatData2 = data2;
                this.formatData4 = this.playContrastData;
                this.formatData5 = data5;
                this.formatData6 = this.buildingContrastData;
                this.formatData7 = data7;
                this.formatData9 = this.monsterChoiceTypeContrastData;
                this.formatData10 = data10;
                this.formatData11 = data11;
                this.formatData12 = this.chatChannelContrastData;

                this.changeReasonOptions.forEach(item => {
                    data13.push({
                        change_reason: item.value,
                        name: item.label
                    })
                })
                this.formatData13 = data13;
                this.formatData15 = data15;
                this.formatData16 = this.loginTypeContrastData;
                this.formatData17 = data17;
            },
            // 去重
            deduplicateData(arr) {
                let list = [];
                return arr.filter((item) => !list.includes(item.market_id) && list.push(item.market_id))
            },

            // 导出超2对照格式
            exportComparisonFormat(num,name) {
                var data = [];
                this.options.forEach(optionItem => {
                    this.formatData10.forEach(data10Item => {
                        if (optionItem.value == data10Item.item_type) {
                            data10Item.item_type_name = optionItem.label;
                        }
                    })
                })
                if (num == 1) {
                    data = this.formatData1;
                } else if (num == 2) {
                    data = this.formatData2;
                } else if (num == 4) {
                    data = this.formatData4;
                } else if (num == 5) {
                    data = this.formatData5;
                } else if (num == 6) {
                    data = this.formatData6;
                } else if (num == 7) {
                    data = this.formatData7;
                } else if (num == 9) {
                    data = this.formatData9;
                } else if (num == 10) {
                    data = this.formatData10;
                } else if (num == 11) {
                    data = this.deduplicateData(this.formatData11);
                } else if (num == 12) {
                    data = this.formatData12;
                } else if (num == 13) {
                    data = this.formatData13;
                } else if (num == 15) {
                    data = this.formatData15;
                } else if (num == 16) {
                    data = this.formatData16;
                }else if (num == 17) {
                    data = this.formatData17;
                }

                var arr = [];
                var arr1 = [];
                var keyArr = [];

                for (var i in data[0]) {
                    arr1.push(i);
                    keyArr.push(i);
                }
                arr.push(arr1);

                data.forEach((item,index) => {
                    var _arr = [];
                    keyArr.forEach(keyItem => {
                        _arr.push(item[keyItem]);
                    })
                    arr.push(_arr);
                })

                const ws= XLSX.utils.aoa_to_sheet(arr);

                /* generate workbook and add the worksheet */
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'sheet1');

                /* save to file */
                XLSX.writeFile(wb, (name + '.csv'));
            }
        }

    }
</script>

<style scoped>

</style>

<style lang="less">
    .prop-img {
        width: 50px;
        height: 50px;
    }

    .el-descriptions-item__label.is-bordered-label {
        background-color: #ffffff !important;
    }
    .el-descriptions-item__content {
        background-color: #fafafa !important;
    }

    .evolutions-entire {
        display: flex;
        align-items: center;
    }

    .material-box {
        display: flex;
        align-items: center;
    }

    .material-content {
        display: flex;
        flex-direction: column;
        text-align: center;
        align-self: flex-end;
    }

    .add-text {
        margin: 0 10px;
    }

    .oid-box {
        display: flex;
        flex-direction: column;
        text-align: center;
    }

    .awake-box {
        display: flex;
        align-items: center;
    }

    .awake-content {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .monster-detail-box {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        border-bottom: 1px #999999 solid;
    }

    .monster-detail-divider {
        display: inline-block;
        width: 1px;
        margin: 0 8px;
        height: auto;
        background-color: #dcdfe6;
    }

    .monster-detail-entire {
        display: flex;
        justify-content: space-between;
    }

    .monster-detail-img {
        text-align: center;
        margin-bottom: 20px;
    }

    .monster-detail-skill {
        display: flex;
        align-items: center;
        margin-bottom: 26px;
    }

    .monster-detail-name {
        font-weight: bold;
    }

    .skill-name {
        margin-bottom: 10px;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/views/home_bak.vue